import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareChangelogQuery } from '@composables/middleware/changelog-query.hook'

import { defineNuxtRouteMiddleware } from '#app'

/** `/customers/{id}/changelog` — every action that touched the customer or anything tagged with it. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const customerId = to.params.id

  if (typeof customerId !== 'string' || !customerId) return

  useMiddlewareChangelogQuery(to, {
    route: 'admin.customer.changelog-data',
    params: { customer_id: customerId },
  })
})
